import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children, requiredRole }) => {
    const organizationID = localStorage.getItem('organizationID');
    const role = localStorage.getItem('role');

    if (!organizationID) return <Navigate to="/" />;
    if (requiredRole && role !== requiredRole) return <Navigate to="/store" />;

    return children;
};

export default ProtectedRoute;
